module.exports = __webpack_public_path__ + "img/departures-planet.0a8a6ca8.svg";